document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('.mobile-nav-toggle');
  var navLinks = document.querySelector('.nav-links');
  if (toggle && navLinks) {
    toggle.addEventListener('click', function () {
      navLinks.classList.toggle('is-open');
      navLinks.style.display = navLinks.classList.contains('is-open') ? 'flex' : '';
    });
  }

  // Header part-number search -> redirects to the search results page
  var headerSearchForm = document.querySelector('[data-header-search]');
  if (headerSearchForm) {
    headerSearchForm.addEventListener('submit', function (e) {
      var input = headerSearchForm.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) {
        e.preventDefault();
      }
    });
  }

  // Newsletter form (Shopify customer newsletter endpoint handles the POST natively)
  var newsletterForms = document.querySelectorAll('[data-newsletter-form]');
  newsletterForms.forEach(function (form) {
    form.addEventListener('submit', function () {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Submitting...';
      }
    });
  });
});
